import script from "./ContactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUs.vue?vue&type=script&setup=true&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=5d5d151b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d5d151b"]])

export default __exports__